const iconsForCategories = [
  'fa-solid fa-hand-holding-heart',
  'fa-solid fa-gauge-simple-high',
  'fa-solid fa-chart-gantt',
  'fa-solid fa-gears',
  'fa-solid fa-briefcase',
  'fa-solid fa-screwdriver-wrench',
  'fa-solid fa-user-tie',
  'fa-solid fa-globe',
  'fa-solid fa-computer',
  'fa-solid fa-building',
  'fa-solid fa-network-wired',
  'fa-solid fa-chart-line',
  'fa-solid fa-industry',
  'fa-solid fa-truck'
]

export default iconsForCategories
